import type { ActionObject, TrackableAction } from '../actions/types'

export enum IconType {
  HELP = '@iconType/HELP',
  HOME = '@iconType/HOME',
  PHONE_CALL = '@iconType/PHONE_CALL',
  PHONE = '@iconType/PHONE',
  USER_ACCOUNT = '@iconType/USER_ACCOUNT',
  PDF_FILE = '@iconType/PDF_FILE',
  SERVICES = '@iconType/SERVICES',
  ARROW_LEFT = '@iconType/ARROW_LEFT',
  ARROW_RIGHT = '@iconType/ARROW_RIGHT',
  INFO = '@iconType/INFO',
  APPS = '@iconType/APPS',
  COMPUTER = '@iconType/COMPUTER',
  CANCELED = '@iconType/CANCELED',
  LOCATION = '@iconType/LOCATION',
  STAR = '@iconType/STAR',
  RECEIPT = '@iconType/RECEIPT',
  EMAIL = '@iconType/EMAIL',
  ADD = '@iconType/ADD',
  WHATSAPP = '@iconType/WHATSAPP',
  WALLET = '@iconType/WALLET',
  CHECK_CIRCLE = '@iconType/CHECK_CIRCLE',
}

export interface IconParams {
  color?: string
  width?: number
  height?: number
  action?: ActionObject<TrackableAction>
}

export type IconSectionType = {
  icon: IconType
  params?: IconParams
}
